import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyProcessIndicationDto, UpsertProcessIndicationRequest, ProcessIndicationStatusUpdateRequest } from '../../models/api/companyProcessIndicationDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyProcessIndicationService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyProcessIndicationDto>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyProcessIndicationDto>>(
      `${this.apiUrl}/${companyId}/process-indications`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertProcessIndicationRequest): Observable<CompanyProcessIndicationDto> {
    return this.http.put<CompanyProcessIndicationDto>(`${this.apiUrl}/${companyId}/process-indications`, request);
  }

  updateStatus(companyId: string, request: ProcessIndicationStatusUpdateRequest): Observable<CompanyProcessIndicationDto> {
    return this.http.patch<CompanyProcessIndicationDto>(`${this.apiUrl}/${companyId}/process-indications/status`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/process-indications`, { params });
  }
}
